module.exports = __webpack_public_path__ + "images/e0f818bb84c081c49ae7546f9ac552cf.emptyData.png";